module.exports = __webpack_public_path__ + "img/hr-brown-hairy-grass-16.df56261f.png";